<template>
  <div>
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <!-- <section class="login-content">
      <div class="mt-5 my-4 text-center">
        <h1><i class="fas fa-phone"></i> เบอร์ติดต่อภายใน</h1>
        <p>บริการที่ผู้ใช้งานสามารถค้นหาเบอร์โทรติดต่อภายใน ผ่านช่องทางนี้.</p>
      </div>
      <div class="tile w-75" style="max-width: 650px">
        <div class="search">
          <div class="input-group input-group-lg mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1"
                ><i class="fas fa-search"></i
              ></span>
            </div>
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="ค้นหาจากชื่อหน่วยงาน..."
            />
          </div>
          <hr />
        </div>
        <table class="table table-bordered">
          <thead class="text-center bg-light">
            <tr>
              <th>ชื่อหน่วยงาน</th>
              <th>หมายเลขติดต่อ</th>
              <th>เบอร์โทรศัพท์มือถือ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in resultQuery" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.mobile }}</td>
              <td hidden ref="col_admin" class="p-0">
                <div class="d-grid gap-2">
                  <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      @click="edit(item)"
                      type="button"
                      class="btn btn-warning rounded-0"
                    >
                      แก้ไข
                    </button>
                    <button
                      @click="delete_(item.id)"
                      type="button"
                      class="btn btn-danger rounded-0"
                    >
                      ลบ
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section> -->

    <section class="login-content">
      <div class="my-4 text-center">
        <!-- <h1>Title Form</h1>
        <p>Sub Title Form</p> -->
        <img src="../../assets/logo.png" alt="" width="120" class="mb-3" />
        <h3 class="tile-title mb-2">โรงพยาบาลวานรนิวาส</h3>
        <h3 class="tile-title mt-2 h5">Wanon Niwat Hospital</h3>
      </div>
      <div class="tile w-75" style="max-width: 350px">
        <div class="tile-head text-center"></div>
        <!-- <form action="">
          <div class="form-group">
            <label class="control-label">Name</label>
            <input
              class="form-control"
              type="text"
              placeholder="Enter full name"
            />
          </div>
          <div class="form-group">
            <label class="control-label">Email</label>
            <input
              class="form-control"
              type="email"
              placeholder="Enter email address"
            />
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-success btn-lg btn-block">
              Login
            </button>
          </div>
        </form> -->
        <div id="__loginbox">
          <div id="msgDiv">asdasd</div>
          <div id="credentials" style="margin: 15px">
            <input id="username" placeholder="ชื่อผู้ใช้ :" type="text" /><input
              id="password"
              placeholder="รหัสผ่าน :"
              type="password"
            /><input
              id="loginbtn"
              type="button"
              value="เข้าสู่ระบบ"
              onclick="submitRequest()"
            />
            <div class="statusmessagerow">
              <div id="statusmessage" class="unshown"></div>
            </div>
          </div>
          <ul id="links">
            <li id="userportallink">
              <a
                id="myaccountcaption"
                style="display: block"
                href="https://192.168.108.1:443/userportal/webpages/myaccount/login.jsp"
                target="_blank"
                text="แก้ไขข้อมูลส่วนตัว"
                >แก้ไขข้อมูลส่วนตัว</a
              >
            </li>
            <li id="registerlink">
              <a
                id="registercaption"
                style="display: none"
                href="#"
                text="Click here to get a username to access the Internet"
                >Click here to get a username to access the Internet</a
              >
            </li>
          </ul>
        </div>
        <div class="tile-footer text-center">
          <div
            class="btn-group-vertical btn-group-lg btn-block"
            role="group"
            aria-label="Basic example"
          >
            <button type="button" class="btn btn-warning">
              <i class="fas fa-phone"></i> TEL IN
            </button>
            <button type="button" class="btn btn-success">
              <i class="fas fa-laptop-medical"></i> IT SERVICE
            </button>
            <button type="button" class="btn btn-danger">
              <i class="fas fa-network-wired"></i> IP ADDRESS CLIENT
            </button>
            <button type="button" class="btn btn-info">
              <i class="fas fa-id-card-alt"></i> IPD CARD
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchQuery: "",
    };
  },
  methods: {
    get() {},
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.data.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        return this.data;
      }
    },
  },
  created() {
    this.$http("https://it-service.wanorn.com/backend/api/phones")
      .then((res) => {
        console.log(res.data);
        this.data = res.data;
      })
      .catch((err) => {});
  },
};
</script>

<style>
.material-half-bg .cover {
  /* background-color: #f7bd6d; */
  background: linear-gradient(to right, #f6df9e, #f8cd55);
  height: 50vh;
}
.content {
  max-width: 650px;
}
#msgDiv {
  text-align: center;
  color: green;
  font-size: 20px;
  font-weight: bold;
}
#username,
#password {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  margin: 6px 0 6px 0;
}
@media (prefers-reduced-motion: reduce) {
  #username,
  #password {
    transition: none;
  }
}
#username,
#password::-webkit-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#username,
#password::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
#username,
#password:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#username,
#password::-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}
#username,
#password::placeholder {
  color: #6c757d;
  opacity: 1;
}
ul {
  list-style-type: none;
}
#links {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}
#userportallink {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
#myaccountcaption {
  text-align: center;
}
#loginbtn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  display: block;
  width: 100%;
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
@media (prefers-reduced-motion: reduce) {
  #loginbtn {
    transition: none;
  }
}
#loginbtn:hover {
  color: #212529;
  text-decoration: none;
}

.btn-group-vertical > .btn,
.btn-group > .btn {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.btn-group-vertical > .btn:hover,
.btn-group > .btn:hover {
  z-index: 1;
}
.btn-group-vertical > .btn.active,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn:focus,
.btn-group > .btn.active,
.btn-group > .btn:active,
.btn-group > .btn:focus {
  z-index: 1;
}
</style>